import { connect } from "react-redux";
import {
  getUser,
  getUserAuthenticated,
  getUserLoading,
  getUserPremium
} from "../../reducers/user/selectors";
import { getLang } from "../../reducers/crossword/selectors";
import { getShowPaywall } from "../../reducers/ui/selectors";
import { getPaymentStatus } from "../../reducers/user/actions";
import { togglePaywall } from "../../reducers/ui/actions";

import Paywall from "./Paywall";

const mapStateToProps = state => ({
  loading: getUserLoading(state),
  lang: getLang(state),
  user: getUser(state),
  authenticated: getUserAuthenticated(state),
  premium: getUserPremium(state),
  show: getShowPaywall(state)
});

const mapDispatchToProps = dispatch => ({
  hidePaywall: () => dispatch(togglePaywall(false)),
  getPaymentStatus: token => dispatch(getPaymentStatus(token))
});

export default connect(mapStateToProps, mapDispatchToProps)(Paywall);



// WEBPACK FOOTER //
// ./src/components/Paywall/PaywallContainer.js